import React from 'react'
import Dashboard from '../Dashboard/index'
import { useAuth0 } from '../../Hooks/auth0'

const AuthLoginRoute = ( {as: Comp, ...props }) => {
    const { isLoggedIn } = useAuth0()
    const alreadyLoggedIn = isLoggedIn() 
    return !alreadyLoggedIn ? <Comp {...props} /> : <Dashboard />
}

export default AuthLoginRoute